import {ProductsRelDocs} from "../../interfaces";
import ProductPriceFormat from "../../../product-price/product-price-format";
import ProductClock from "../../../product-clock/product-clock";
import {ProductDepartmentEnum} from "../../../enums/product-department-enum";
import DiscountBadge from '../../../../../ui/discount-badge/discount-badge';
interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    isGoogleShoppingFeed?: boolean,
}
/**
 * the entry point
 */
const PRDPrice = (props: IProductBuyButtonProps) => {

    const product = props.product;
    const withCouponEnabled = product.couponCampaignID > 0;
    const isWithCoupon = withCouponEnabled && !props.isGoogleShoppingFeed && product.couponPrice > 0;
    const isFreeForWCA = product.freeForWCA || false;
    const isSamePrice = product.msrp === product.skuPrice;


    const departmentID = Number(product.departmentID) || 0;
    const isSubscriptionVariants = product.isProductOptions && departmentID === ProductDepartmentEnum.Subscription;
    const variantText = isSubscriptionVariants ? (product.optionName === 'Annual' ? '/year' : '/month') : '';

    return (

            <>
                {
                    <div className={`flex flex-col`}>
                        {/* prices row #1: different prices / with coupon */}
                        {
                            (product.couponPrice > 0 || !isSamePrice) &&
                            <div className="flex items-center">

                                {/* MSRP price */}
                                <div className="text-sm lg:text-lg mr-2 text-gray-400">
                                    <s aria-hidden="true"><ProductPriceFormat price={ product.msrp } accessible={ false } /></s>
                                    <span className="sr-only">Full Price ${ product.msrp }</span>
                                </div>

                                {/* on sale: sku price if 'with coupon' price exists */}
                                {
                                    (product.couponPrice > 0 && !isSamePrice) &&
                                    <div className="text-sm lg:text-lg mr-2 text-gray-400">
                                        On Sale <span><ProductPriceFormat price={product.skuPrice} /></span>
                                    </div>
                                }
                            </div>
                        }

                        {/* prices row #1: same price */}
                        {/*
                            (isSamePrice && product.couponPrice <= 0) &&
                            <div className="flex items-center text-base ">Now</div>

                         */}

                        {/* prices row #2 */}
                        <div className="flex items-center">

                            {/* main price: if 'with coupon' exists -> 'with coupon' price, otherwise sku price */}
                            <div className="text-2xl lg:text-3xl font-bold">
                                {
                                    isWithCoupon &&
                                    <span>
                            <ProductPriceFormat price={ product.couponPrice } />&nbsp;

                                        <span className="sr-only">
                                With Coupon: <span>{ product.couponCode }</span>
                            </span>
                        </span>
                                }

                                {!isWithCoupon && isFreeForWCA &&
                                    <span className="prd-price-nofree"><ProductPriceFormat price={product.skuPrice}/>
                                    <span className="text-base font-normal"> or</span><span className="text-base font-bold"> FREE with </span>
                                    <span><a className="text-base font-bold text-blue-150" href="/subscriptions">Waves Creative Access</a></span>
                                </span>}
                                { !isWithCoupon && !isFreeForWCA && <span className="prd-price-normal"><ProductPriceFormat price={ product.skuPrice } /> <span className="text-lg font-normal">{variantText}</span></span> }

                            </div>

                            {/* discount red tag */}
                            {
                                product.discount > 0 &&
                                <DiscountBadge discount={product.discount} />
                            }

                            {/* timer */}
                            {
                                product.saleEndDate &&
                                <div className="ml-2">
                                    <ProductClock saleEndDate={ new Date(product.saleEndDate) } textColor="text-white" showSeconds={true} />
                                </div>
                            }
                        </div>

                        {/* prices row #3 */}
                        {
                            product.couponCode &&
                            <div className="flex items-center">
                                <div className="lg:text-lg font-bold" aria-hidden={ true }>With Coupon: <span className="text-red">{ product.couponCode }</span></div>
                            </div>
                        }


                    </div>
                }
            </>
    )
};

export default PRDPrice;